import Router from 'vue-router'

export default new Router({
    routes: [{
            path: '/Login',
            component: resolve => require(['@/page/Login.vue'], resolve),
        }, {
            path: '/',
            component: resolve => require(['@/page/index.vue'], resolve),
        },
        {
            path: '/index',
            component: resolve => require(['@/page/index.vue'], resolve),
            redirect: '/banner/swiper',
            children: [
                // 设置  
                {
                    path: '/set_up/add_menu',
                    component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
                },
                {
                    path: '/set_up/menu_list',
                    component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
                },
                {
                    path: '/set_up/add_role',
                    component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
                },
                {
                    path: '/set_up/role_list',
                    component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
                },
                {
                    path: '/set_up/user_list',
                    component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
                },
                {
                    path: '/set_up/addStaff',
                    component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
                },
                // 首页banner
                {
                    path: '/banner/swiper',
                    component: resolve => require(['@/page/banner/swiper.vue'], resolve)
                },
                {
                    path: '/banner/add_swiper',
                    component: resolve => require(['@/page/banner/add_swiper.vue'], resolve)
                },
                //商品列表nav1      
                {
                    path: '/nav1/add_goods_type',
                    component: resolve => require(['@/page/nav1/add_goods_type.vue'], resolve)
                },
                // 直播商品列表
                {
                    path: '/nav1/live_product_list',
                    component: resolve => require(['@/page/nav1/live_product_list.vue'], resolve)
                },
                {
                    path: '/nav1/goods_type',
                    component: resolve => require(['@/page/nav1/goods_type.vue'], resolve)
                },
                {
                    path: '/nav1/add_goods_classify',
                    component: resolve => require(['@/page/nav1/add_goods_classify.vue'], resolve)
                },
                {
                    path: '/nav1/goods_classify',
                    component: resolve => require(['@/page/nav1/goods_classify.vue'], resolve)
                },
                {
                    path: '/nav1/comment_detail',
                    component: resolve => require(['@/page/nav1/comment_detail.vue'], resolve)
                },
                {
                    path: '/nav1/comment_list',
                    component: resolve => require(['@/page/nav1/comment_list.vue'], resolve)
                },
                {
                    path: '/nav1/shop_list',
                    component: resolve => require(['@/page/nav1/shop_list.vue'], resolve)
                },
                {
                    path: '/nav1/shop_grouping',
                    component: resolve => require(['@/page/nav1/shop_grouping.vue'], resolve)
                },
                {
                    path: '/nav1/add_shop',
                    component: resolve => require(['@/page/nav1/add_shop.vue'], resolve)
                },
                {
                    path: '/nav1/add_grouping',
                    component: resolve => require(['@/page/nav1/add_grouping.vue'], resolve)
                },
                //nav2
                {
                    path: '/nav2/invitation_list',
                    component: resolve => require(['@/page/nav2/invitation_list.vue'], resolve)
                },
                {
                    path: '/nav2/user_detail',
                    component: resolve => require(['@/page/nav2/user_detail.vue'], resolve)
                },

                {
                    path: '/nav2/wx_user_list',
                    component: resolve => require(['@/page/nav2/wx_user_list.vue'], resolve)
                },
                {
                    path: '/user/vip_card_list',
                    component: resolve => require(['@/page/user/vip_card_list.vue'], resolve)
                },
                {
                    path: '/user/add_vip_card',
                    component: resolve => require(['@/page/user/add_vip_card.vue'], resolve)
                },
                // {
                //   path: '/nav2/invitation_set',
                //   component: resolve => require(['@/page/nav2/invitation_set.vue'], resolve)
                // },
                // {
                //   path: '/nav2/put_forward',
                //   component: resolve => require(['@/page/nav2/put_forward.vue'], resolve)
                // },
                // 商品订单 nav3
                {
                    path: '/nav3/order',
                    component: resolve => require(['@/page/nav3/order.vue'], resolve)
                },
                {
                    path: '/nav3/batch',
                    component: resolve => require(['@/page/nav3/batch.vue'], resolve)
                },
                {
                    path: '/nav3/order_detail',
                    component: resolve => require(['@/page/nav3/order_detail.vue'], resolve)
                },
                {
                    path: '/store/store_list',
                    component: resolve => require(['@/page/store/store_list.vue'], resolve)
                },
                {
                    path: '/store/store_apply',
                    component: resolve => require(['@/page/store/store_apply.vue'], resolve)
                },
                {
                    path: '/nav3/return_goods',
                    component: resolve => require(['@/page/nav3/return_goods.vue'], resolve)
                },
                {
                    path: '/nav3/order_returned_detail',
                    component: resolve => require(['@/page/nav3/order_returned_detail.vue'], resolve)
                },
                // 个人中心设置
                {
                    path: '/setting/staff',
                    component: resolve => require(['@/page/setting/staff.vue'], resolve)
                },
                {
                    path: '/setting/add_staff',
                    component: resolve => require(['@/page/setting/add_staff.vue'], resolve)
                },
                {
                    path: '/setting/order',
                    component: resolve => require(['@/page/setting/order.vue'], resolve)
                },
                {
                    path: '/setting/store_pickup_reward',
                    component: resolve => require(['@/page/setting/store_pickup_reward.vue'], resolve)
                },
                {
                    path: '/setting/questions',
                    component: resolve => require(['@/page/setting/questions.vue'], resolve)
                },
                {
                    path: '/setting/add_questions',
                    component: resolve => require(['@/page/setting/add_questions.vue'], resolve)
                },
                {
                    path: '/setting/about_us',
                    component: resolve => require(['@/page/setting/about_us.vue'], resolve)
                },
                {
                    path: '/setting/video_setting',
                    component: resolve => require(['@/page/setting/video_setting.vue'], resolve)
                },
                {
                    path: '/setting/return_goods_address',
                    component: resolve => require(['@/page/setting/return_goods_address.vue'], resolve)
                },

                // 余额提现独立保留，分销/推三页面不再注册。
                {
                    path: '/finance/cash_withdrawal',
                    component: resolve => require(['@/page/distribution/cash_withdrawal.vue'], resolve)
                },

                // 优惠券
                {
                    path: '/coupon/new_people',
                    component: resolve => require(['@/page/coupon/new_people.vue'], resolve)
                }, // 新人好礼
                {
                    path: '/coupon/add_people',
                    component: resolve => require(['@/page/coupon/add_people.vue'], resolve)
                }, // 添加 - 新人好礼
                {
                    path: '/coupon/coupon_list',
                    component: resolve => require(['@/page/coupon/coupon_list.vue'], resolve)
                }, // 优惠券管理
                {
                    path: '/coupon/coupon_detail',
                    component: resolve => require(['@/page/coupon/coupon_detail.vue'], resolve)
                }, // 优惠券管理 - 优惠券详情
                {
                    path: '/coupon/receive_coupon',
                    component: resolve => require(['@/page/coupon/receive_coupon.vue'], resolve)
                }, // 领取优惠券列表 
                {
                    path: '/coupon/add_coupon',
                    component: resolve => require(['@/page/coupon/add_coupon.vue'], resolve)
                }, // 优惠券管理 - 添加优惠券 

            ]
        },
    ],
})



// WEBPACK FOOTER //
// ./src/router/index.js